import React, { memo, useMemo } from 'react'
import dynamic from 'next/dynamic'
import { FormattedMessage, useIntl } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Page from 'components/layout/Page'
import usePageProps from 'hooks/usePageProps'
import MainBanner from 'components/shared/MainBanner'
import useMediaQuery from '@mui/material/useMediaQuery'
import Skeleton from '@mui/material/Skeleton'
import Button from '@mui/material/Button'
import MainImage from 'public/img/sucursales/imagen_sucursales.png'
import sx from './styles'
import ToggleSection from './ToggleSection'

const ReviewsAndPressSkeleton = dynamic(() => import('components/shared/GoogleReviewsAndPress/ReviewsAndPressSkeleton'))

const GoogleReviewsAndPress = dynamic(
  () => import('components/shared/GoogleReviewsAndPress'),
  {
    loading: () => (
      <ReviewsAndPressSkeleton
        showPress
        sx={sx.googleReviewsContainer}
      />
    ),
    ssr: false,
  },
)

const RatingComponent = dynamic(
  () => import('components/shared/Rating'),
  {
    loading: () => (
      <Skeleton
        variant="rectangular"
        animation="wave"
        height={160}
        width="100%"
      />
    ),
    ssr: false,
  },
)

const mainBanner = {
  title: 'Visita nuestras sucursales y vive una experiencia única.',
  // subtitle: get(VTAResult, 'data.acf.subtitle', ''),
  mainImage: {
    id: 1192,
    title: 'Visita nuestras sucursales y vive una experiencia única.',
    url: MainImage,
    link: '/sucursales',
    alt: 'Visita nuestras sucursales y vive una experiencia única.',
    description: 'Visita nuestras sucursales y vive una experiencia única.',
    caption: 'Visita nuestras sucursales y vive una experiencia única.',
    type: 'image',
    subtype: 'webp',
    width: 1046,
    height: 624,
  },
  video_url: '',
  image_url: MainImage,
}

const scrollTo = (id) => {
  const element = document.getElementById(id)?.offsetTop
  const top = element - 200
  setTimeout(() => {
    window.scroll({ top, behavior: 'smooth' })
  }, 500)
}

const Sucursales = () => {
  const { landingBranches } = usePageProps()
  const { formatMessage: f } = useIntl()
  const isEasyVariant = true // set 1 to get VTA copys
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const raitng = useMemo(() => [
    {
      id: 'rating',
      class: sx.ratingComponent,
      component: (
        <RatingComponent
          text={f({ id: 'SYC_RATING_TEXT' })}
          textVariant="h3"
          variant
        />
      ),
      visible: true,
      position: 3,
    },
  ], [])

  return (
    <>
      <Page>
        <Box sx={isMobile ? sx.containerMobile : ''}>
          <MainBanner
            {...mainBanner}
            sx={sx.mainContainer}
          >
            <Button
              fullWidth
              color="primary"
              variant="special"
              sx={sx.btn}
              onClick={() => scrollTo('toggle-section')}
            >
              <FormattedMessage id="MAIN_BANNER_CTA" />
            </Button>
          </MainBanner>
          <Grid
            size={12}
            container
          >
            {raitng
              .filter((i) => i.visible)
              .sort((a, b) => a.position - b.position)
              .map((section) => (
                <Grid
                  size={12}
                  sx={section.class ? section.class : null}
                  key={section.id}
                >
                  {section.component}
                </Grid>
              ))}
          </Grid>

          <Box>
            <Grid
              size={12}
              container
              id="toggle-section"
            >
              {landingBranches
                ?.map((item) => (
                  <ToggleSection
                    item={item}
                  />
                ))}
            </Grid>
          </Box>

          <GoogleReviewsAndPress
            variant="row"
            title={isEasyVariant ? 'SYC_REVIEWS_TITLE_VARIANT_1_EASY' : 'SYC_REVIEWS_TITLE_VARIANT_1'}
            buttonLabel="SYC_SEE_ALL_REVIEWS_1"
            sx={sx.googleReviewsContainer}
          />
        </Box>
      </Page>
    </>
  )
}
export default memo(Sucursales)
